export function getObjectiveScoringMetadata({
  mode,
  selectedSectionIndices,
  totalPartCount,
  groupId,
}) {
  const selectedParts = (Array.isArray(selectedSectionIndices) ? selectedSectionIndices : [])
    .map(index => Number(index) + 1)
    .filter(part => Number.isInteger(part) && part > 0);
  const isPartialPractice = !groupId
    && mode === 'practice'
    && selectedParts.length > 0
    && selectedParts.length < Number(totalPartCount);

  return isPartialPractice
    ? { scoring_scope: 'selected_part_practice', selected_parts: selectedParts }
    : { scoring_scope: 'full_section', selected_parts: [] };
}
